<app-navbar title="Dodawanie wydarzenia">
	<button class="btn btn-primary me-2" (click)="submit()">Zapisz</button>
	<a routerLink="/tourism-calendar/" class="btn btn-danger"> <i class="far fa-calendar-alt"></i> Kalendarz </a>
</app-navbar>

<form class="container my-4" (submit)="submit()">
	<div class="form-floating mb-3">
		<input
			class="form-control"
			id="name"
			name="name"
			[(ngModel)]="event.name"
			[ngClass]="{ error: this.errors.name }"
		/>
		<label for="name">Nazwa wydarzenia</label>
	</div>

	<div class="row mb-3">
		<div class="col-6">
			<div class="form-floating">
				<input
					type="datetime-local"
					class="form-control"
					name="date_from"
					id="date_from"
					[appUtcModel]="event.date_from"
					(appUtcModelChange)="
						event.date_from = $event;
						calculateDateTo();
						calculateDatePrepare();
						calculateDateDeadline();
						calculateDateAuto()
					"
					[ngClass]="{ error: this.errors.date_from }"
				/>
				<label for="date_from">Data rozpoczęcia</label>
			</div>
		</div>
		<div class="col-6">
			<div class="form-floating">
				<input
					type="datetime-local"
					class="form-control"
					name="date_to"
					id="date_to"
					[appUtcModel]="event.date_to"
					(appUtcModelChange)="event.date_to = $event; calculateDateDeadline(); calculateDateAuto()"
					[ngClass]="{ error: this.errors.date_to }"
				/>
				<label for="date_to">Data zakończenia</label>
			</div>
		</div>
	</div>
	<app-tourism-events-vehicle-add
		[min]="event.date_from"
		[max]="event.date_to"
		[vehicles]="vehicles"
		[editable]="lockEdit"
		[alreadyAddedVehicles]="event.vehicles"
		(emitVehiclesArray)="setVehicles($event)"
	></app-tourism-events-vehicle-add>
	<div class="card mb-3">
		<div class="card-body">
			<div class="row mt-2" *ngFor="let driver of event.drivers_departure; let driverIndex = index">
				<div class="col">
					<label for="program_date_from">Kierowca</label>
					<ng-select
						name="driversDeparture_{{ driverIndex }}"
						[(ngModel)]="event.drivers_departure[driverIndex].driver"
						placeholder="(wybierz)"
						bindLabel="name"
						[disabled]="lockEdit || driver?.confirmed"
						(change)="
							checkConfirmSalaryDrivers(driver); checkEditedDriverDocument(event); changeDriver(driver)
						"
						(focus)="onFocusedDriver(event.drivers_departure[driverIndex].driver)"
					>
						<ng-option *ngFor="let item of drivers" [value]="item.id"
							>{{ item.last_name }} {{ item.first_name }}</ng-option
						>
					</ng-select>
					<a class="cursor-pointer" (click)="driverModalOpen(driver)" *ngIf="lockEdit">Czas pracy kierowcy</a>
				</div>
				<div class="col">
					<label for="drivers_{{ driver.type }}_{{ driverIndex }}_date_from">Data od</label>
					<input
						type="datetime-local"
						class="col-sm-2 form-control"
						name
						name="drivers_{{ driver.type }}_{{ driverIndex }}_date_from"
						id="drivers_{{ driver.type }}_{{ driverIndex }}_date_from"
						[appUtcModel]="driver.date_from"
						(appUtcModelChange)="driver.date_from = $event"
						(change)="checkEditedDriverDocument(event)"
						[readonly]="driver.dateFromAuto"
						[disabled]="lockEdit || driver?.confirmed"
					/>
					<div class="col form-check mt-1">
						<input
							class="form-check-input"
							type="checkbox"
							[(ngModel)]="driver.dateFromAuto"
							(change)="autoDate('drivers_departure', driver, 'dateFromAuto', 'date_from')"
							name="drivers_{{ driver.type }}_{{ driverIndex }}_dateFromAuto"
							id="drivers_{{ driver.type }}_{{ driverIndex }}_dateFromAuto"
							[disabled]="lockEdit || driver?.confirmed"
						/>
						<label class="form-check-label" for="drivers_{{ driver.type }}_{{ driverIndex }}_dateFromAuto">
							Automatyczna "Data od"
						</label>
					</div>
				</div>
				<div class="col">
					<label for="drivers_{{ driver.type }}_{{ driverIndex }}_date_to">Data do</label>
					<input
						type="datetime-local"
						class="col-sm-2 form-control"
						name="drivers_{{ driver.type }}_{{ driverIndex }}_date_to"
						id="drivers_{{ driver.type }}_{{ driverIndex }}_date_to"
						[appUtcModel]="driver.date_to"
						(appUtcModelChange)="driver.date_to = $event"
						(change)="checkEditedDriverDocument(event)"
						[readonly]="driver.dateToAuto"
						[disabled]="lockEdit || driver?.confirmed"
					/>
					<div class="col form-check mt-1">
						<input
							class="form-check-input"
							type="checkbox"
							[(ngModel)]="driver.dateToAuto"
							(change)="autoDate('drivers_departure', driver, 'dateToAuto', 'date_to')"
							name="drivers_{{ driver.type }}_{{ driverIndex }}_dateToAuto"
							id="drivers_{{ driver.type }}_{{ driverIndex }}_dateToAuto"
							[disabled]="lockEdit || driver?.confirmed"
						/>
						<label class="form-check-label" for="drivers_{{ driver.type }}_{{ driverIndex }}_dateToAuto">
							Automatyczna "Data do"
						</label>
					</div>
				</div>
				<div class="col">
					<div class="mt-4">
						<a
							target="_blank"
							routerLink="/drivers-calendar/{{ driver.date_from | date: 'yyyy-MM-dd' }}"
							[fragment]="driver.driver"
							*ngIf="lockEdit"
						>
							<i class="far fa-calendar-alt"></i>
						</a>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col mt-2">
					<div class="btn btn-primary" (click)="driverAddRow('drivers_departure')" *ngIf="!lockEdit">
						Dodaj kierowce
					</div>
				</div>
			</div>

			<!-- <label class="form-label">Kierowcy</label>
			<ng-select name="driversDeparture_0" [(ngModel)]="event.drivers_departure[0]" placeholder="(wybierz)" [multiple]="true">
				<ng-option *ngFor="let item of drivers" [value]="item.id">{{ item.last_name }} {{ item.first_name }}</ng-option>
			</ng-select> -->
		</div>
	</div>
	<div class="mb-3">
		<label class="form-label">Klient</label>
		<app-tourism-events-organization
			[client]="event.client"
			(clientData)="sendData($event)"
		></app-tourism-events-organization>
	</div>
	<div class="form-floating mb-3">
		<input
			type="text"
			class="form-control"
			id="text_program"
			name="text_program"
			[(ngModel)]="event.text_program"
		/>
		<label for="text_program">Uwagi</label>
	</div>
</form>
